// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const UnlockIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="UnlockIcon" ref={forwardedRef} {...props}>
      <path d="M9.25 11h1.5v3h-1.5z" />
      <path d="M8.25 4.5h3.5a1.5 1.5 0 0 1 1.5 1.5v2H4.5a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-.75V6a3 3 0 0 0-3-3h-3.5a3 3 0 0 0-3 3h1.5a1.5 1.5 0 0 1 1.5-1.5M5 9.5h10v6H5z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const UnlockIcon = /* @__PURE__ */ Object.assign(UnlockIconComponent, {
  displayName: 'UnlockIcon',
});
